/**
 * Checks if a via configuration is user-created (not auto-generated).
 * @param viaConfig Via configuration to check
 * @returns Whether the via configuration is user-created (not auto-generated)
 */
export function isUserCreatedViaConfig(viaConfig) {
    // A user-created via config does not have a parentConfigUid
    return !viaConfig.parentConfigUid;
}
export function isSubSampledViaConfig(viaConfig) {
    // A sub-sampled via config has a parentConfigUid
    return !isUserCreatedViaConfig(viaConfig);
}
export function getUserCreatedViaConfigs(viaConfigs) {
    const configsArray = Array.isArray(viaConfigs) ? viaConfigs : Object.values(viaConfigs);
    return configsArray.filter(isUserCreatedViaConfig).sort((a, b) => a.order - b.order);
}
/**
 * Generates a deterministic UID for a sub-sampled via configuration based on its parent and segments.
 *
 * @param parentUid - The UID of the parent via configuration
 * @param segments - The segments used in the sub-sampled configuration
 * @returns A deterministic UID in format: `${parentUid}_sub_${segmentKeys}`
 */
export function generateSubSampledConfigUid(parentUid, segments) {
    const segmentKeys = segments.map((s) => s.key).join(",");
    return `${parentUid}_sub_${segmentKeys}`;
}
export function getSubSampledConfigsFromParentUid(allConfigs, parentConfigUid) {
    const configsArray = Array.isArray(allConfigs) ? allConfigs : Object.values(allConfigs);
    return configsArray.filter(isSubSampledViaConfig).filter((config) => config.parentConfigUid === parentConfigUid);
}
/**
 * Generates all possible contiguous sub-sampled configurations from a parent via configuration.
 * Creates configurations for all contiguous segment sequences (e.g., A, AB, ABC, B, BC, etc.)
 * excluding the full parent configuration itself.
 *
 * Sub-sampled configs are marked as readonly and auto-generated with parentConfigUid set.
 * They inherit the parent's name and order but are filtered from UI display.
 *
 * @param parentConfig - The parent via configuration to generate sub-samples from
 * @returns Array of sub-sampled via configurations with contiguous segment sequences
 */
export function generateSubSampledConfigs(parentConfig) {
    if (parentConfig.segments.length <= 1) {
        return [];
    }
    const subSampledConfigs = [];
    const segments = parentConfig.segments;
    for (let startIndex = 0; startIndex < segments.length; startIndex++) {
        for (let endIndex = startIndex; endIndex < segments.length; endIndex++) {
            const selectedSegments = segments.slice(startIndex, endIndex + 1);
            if (selectedSegments.length === segments.length) {
                continue;
            }
            subSampledConfigs.push({
                uid: generateSubSampledConfigUid(parentConfig.uid, selectedSegments),
                name: parentConfig.name,
                order: parentConfig.order,
                segments: selectedSegments,
                enabled: parentConfig.enabled,
                readonly: true,
                parentConfigUid: parentConfig.uid,
            });
        }
    }
    return subSampledConfigs;
}
//# sourceMappingURL=subSampling.js.map